import { Box, Button, Card } from "@mui/material";
import React from "react";
import Flx from "../layout/Flx";
import { AddBusinessOutlined, AddRounded } from "@mui/icons-material";
import Txt from "../typography/Txt";

const EmptyStateCard = ({
  icon = <AddBusinessOutlined className="thin" />,
  title,
  description,
  buttonText,
  size = "large",
  buttonStartIcon = <AddRounded className="thin" />,
  buttonEndIcon,
  onClick,
  sx,
}) => {
  return (
    <Card
      sx={{
        py: 6,
        px: 4,
        ".MuiButtonBase-root": {
          fontSize: "12px !important",

          ".MuiSvgIcon-root": {
            fontSize: "16px !important",
          },
        },
        ...sx,
      }}
    >
      <Flx g={1} center fw column>
        <Box
          sx={{
            ".MuiSvgIcon-root": {
              fontSize: "36px",
            },
          }}
        >
          {icon}
        </Box>
        <Flx column g={0.5}>
          <Txt sx={{ fontSize: "15px" }} bold center>
            {title}
          </Txt>
          <Txt secondary center>
            {description}
          </Txt>
        </Flx>
        <Button
          sx={{ mt: 2 }}
          size={size}
          startIcon={buttonStartIcon}
          endIcon={buttonEndIcon}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </Flx>
    </Card>
  );
};

export default EmptyStateCard;
